
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

// Vehicle type distribution data
const vehicleTypeDistribution = [
  { name: 'Motorcycles', value: 55, color: '#0088FE' },
  { name: 'Passenger Cars', value: 20, color: '#00C49F' },
  { name: 'Pickup Trucks', value: 12, color: '#FFBB28' },
  { name: 'SUVs', value: 8, color: '#FF8042' },
  { name: 'Commercial Vehicles', value: 5, color: '#8884d8' },
];

const VehicleDistribution = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        Vehicle Distribution
      </h3>
      
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={vehicleTypeDistribution}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={80}
              fill="#8884d8"
              label={({name, percent}) => `${name}: ${(percent * 100).toFixed(0)}%`}
            >
              {vehicleTypeDistribution.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => `${value}%`} />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
      
      <div className="mt-6 grid grid-cols-2 gap-4">
        <div className="p-4 bg-blue-50 rounded">
          <h4 className="text-sm font-medium text-gray-700">Key Insight</h4>
          <p className="text-sm text-gray-600 mt-1">
            Motorcycles represent the largest vehicle segment at 55%, indicating a strong opportunity for our motorcycle-focused promotions.
          </p>
        </div>
        <div className="p-4 bg-purple-50 rounded">
          <h4 className="text-sm font-medium text-gray-700">Trend Analysis</h4>
          <p className="text-sm text-gray-600 mt-1">
            Passenger cars and SUVs are showing 3% YoY growth, suggesting an opportunity to increase premium fuel offerings.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VehicleDistribution;
